<template>
  <main>
    <Transition name="fade">
      <Loader v-if="!$page || !$beet.isReady" />
    </Transition>
    <template v-if="$page && $beet.isReady">
      <Banner :content="bannerContent" />
      <PromoSection :content="promoSection" />
      <DetailedCardSection :cards="packages" />
      <QuestionSection />
    </template>
  </main>
</template>

<script>
import Banner from '@/components/sections/Banner.vue'
import DetailedCardSection from '@/components/sections/DetailedCardSection.vue'
import PromoSection from '@/components/sections/PromoSection.vue'
import QuestionSection from '@/components/sections/QuestionSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  mixins: [PageMetaMixin],
  name: 'Packages',
  components: { Banner, DetailedCardSection, Loader, PromoSection, QuestionSection },
  beetPage: 'packages',
  computed: {
    bannerContent() {
      return {
        image: this.$page.header.image,
        subtitle: this.$page.header.subtitle,
        title: this.$page.header.title,
      }
    },
    packages() {
      return Object.values(this.$beet.packages)
        .toSorted((packageA, packageB) => {
          return (
            (packageA.sort_order ?? 100) +
            Number(packageA.is_promo) * 1000 -
            ((packageB.sort_order ?? 100) + Number(packageB.is_promo) * 1000)
          )
        })
        .map((pack) => {
          return {
            ...pack,
            type: 'package',
          }
        })
    },
    promoSection() {
      return {
        special: this.$beet.options.discounts.content,
        text: this.$page.description,
      }
    },
  },
}
</script>
